export default __webpack_public_path__ + "static/media/contacto.b9c278bd.png";